module.exports = __webpack_public_path__ + "media/entities/2901-0aeb6e0c.png";